import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { VITALIK, TRANSFER_TOPIC } from "../../integration.js";
// WHYPE — wrapped native HYPE on Hyperliquid's EVM side. Standard ERC-20
// (balanceOf/name/symbol/decimals); good target for generic contract-reads.
const WHYPE = "0x5555555555555555555555555555555555555555";
export const HYPERLIQUID_TEST_CONFIG = {
    balance: { address: VITALIK },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.hyperliquid,
        fixture: "getBalanceHyperliquid",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: WHYPE,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.hyperliquid,
        fixture: "getTokenBalanceHyperliquid",
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.hyperliquid,
        fixture: "getBlockByNumberHyperliquid",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.hyperliquid,
        fixture: "getBlockByHashHyperliquid",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.hyperliquid,
        fixture: "getBlockTransactionsHyperliquid",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.hyperliquid,
        fixture: "getTransfersHyperliquid",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasHyperliquid",
    },
    // traceTransactionQuery intentionally omitted: hyperliquid's upstream RPC
    // does not expose debug_traceTransaction, so exercising the method here
    // always yields a server error. Remove this comment and restore the entry
    // once the upstream gains tracing support.
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.hyperliquid,
        fixture: "getReceiptHyperliquid",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.hyperliquid,
        fixture: "getTransactionByHashHyperliquid",
    },
    codeQuery: {
        address: WHYPE,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.hyperliquid,
        fixture: "getCodeHyperliquid",
    },
    logsQuery: {
        // WHYPE Transfer logs — 50-block window for density (single block had 0).
        address: WHYPE,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.hyperliquid - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.hyperliquid),
        fixture: "getLogsHyperliquid",
    },
    simulateCallQuery: {
        to: WHYPE,
        data: "0x70a08231000000000000000000000000d8da6bf26964af9d7eed9e03e53415d37aa96045",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.hyperliquid,
        fixture: "simulateCallHyperliquid",
    },
};
